import { resolveToTypeWrapper } from './resolve-to-type-wrapper.util';
export function wrapDependencyAsResolvable(dependency) {
    let constraints;
    let typeWrapper;
    if (Array.isArray(dependency)) {
        /** The dependency is a [ID, options] pair. Let's parse it as such. */
        const [id, options] = dependency;
        /** Perform some very basic sanity checking on the pair. */
        if (id == null || options == null) {
            // TODO: make this more descriptive
            throw Error('The dependency pair was not instantiated correctly.');
        }
        if (typeof options === 'number') {
            constraints = options;
        }
        typeWrapper = resolveToTypeWrapper(id);
    }
    else {
        /** The dependency is an injectable identifier. */
        typeWrapper = resolveToTypeWrapper(dependency);
    }
    return {
        constraints,
        typeWrapper,
    };
}
//# sourceMappingURL=wrap-resolvable-dependency.js.map